import React from "react"

import LoadingCard from "../LoadingCard"
import Text from "../../../../../_components/Text"
import { getAnnualSales } from "../../../../../api/sales"
import { formatCurrencyValue, decimalFormat } from "../../../../../utils"

import Page from "../../../../../_components/Layout/Page"
import Row from "../../../../../_components/Layout/Row"
import Column from "../../../../../_components/Layout/Column"
import LoadingInput from "../../../../../_components/LoadingInput"

const monthSelect = [
  { id: "1", name: "Janeiro" },
  { id: "2", name: "Fevereiro" },
  { id: "3", name: "Março" },
  { id: "4", name: "Abril" },
  { id: "5", name: "Maio" },
  { id: "6", name: "Junho" },
  { id: "7", name: "Julho" },
  { id: "8", name: "Agosto" },
  { id: "9", name: "Setembro" },
  { id: "10", name: "Outubro" },
  { id: "11", name: "Novembro" },
  { id: "12", name: "Dezembro" },
]

const currentYear = new Date().getFullYear();
const startYear = 2019


export default (props) => {
  const ref = React.useRef(null)
  const [loading, setLoading] = React.useState(false)
  const [data, setData] = React.useState({ year: 0, month: 0, daily: 0 })
  const [date, setDate] = React.useState({ year: "", month: "", weekday: "" })
  const [theYear, setTheYear] = React.useState(new Date().getFullYear().toString())
  const [theMonth, setTheMonth] = React.useState((new Date().getMonth() + 1).toString())
  const [theWritenMonth, setTheWritenMonth] = React.useState(monthSelect[new Date().getMonth()].name)


  const dataSelect = Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
    const year = startYear + i
    return { id: year, name: year.toString() }
  }).reverse()



  function onChange(e) {
    setData({})

    let { name, value } = e.target

    if (name == "year_param") {
      setTheYear(value)


      getAnnualSales({ param_year: value, param_month: theMonth })
        .then((data) => {
          data.year = formatCurrencyValue(data.year)
          data.month = formatCurrencyValue(data.month)
          data.daily = formatCurrencyValue(data.daily)
          setData(data)
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false)
        })
    }


    if (name == "month_param") {
      setTheMonth(value)


      {
        monthSelect.map((selectedData) => (
          value === selectedData.id ? setTheWritenMonth(selectedData.name) : null
        ))
      }


      getAnnualSales({ param_year: theYear, param_month: value })
        .then((data) => {
          data.year = formatCurrencyValue(data.year)
          data.month = formatCurrencyValue(data.month)
          data.daily = formatCurrencyValue(data.daily)
          setData(data)
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false)
        })
    }

    // if (name == "day_param") {
    //   setTheMonth(value)


    //   getAnnualSales({ param_year: theYear ,param_month: theMonth, param_day: value })
    //     .then((data) => {
    //       data.year = formatCurrencyValue(decimalFormat(data.year))
    //       data.month = formatCurrencyValue(decimalFormat(data.month))
    //       data.daily = formatCurrencyValue(decimalFormat(data.daily))
    //       setData(data)
    //       setLoading(false)
    //     })
    //     .catch((error) => {
    //       setLoading(false)
    //     })
    // }

  }

  React.useEffect(() => {
    const date = new Date()
    setDate({
      year: date.toLocaleDateString("pt-BR", { year: "numeric" }),
      month: date.toLocaleDateString("pt-BR", { month: "long" }),
      weekday: date.toLocaleDateString("pt-BR", { weekday: "long" }),
    })
    setLoading(true)
    setTheWritenMonth(monthSelect[date.getMonth()].name)
    getAnnualSales({ param_year: theYear, param_month: theMonth })
      .then((data) => {
        data.year = formatCurrencyValue(data.year)
        data.month = formatCurrencyValue(data.month)
        data.daily = formatCurrencyValue(data.daily)
        setData(data)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }, [ref.current])


  return (
    <Row>
      <Column col="12">
        <Text color="primary" fontSize="1.4em" className="pb-2 mb-3">
          Resumo de faturamento
        </Text>
      </Column>
      <Column xs="12" md="4" lg="4" xl="4">
        <LoadingCard
          loading={loading}
          title={`Ano, ${theYear}`}
          amountValue={data.year}
          selectComponent={

            <LoadingInput
              className="col-4 d-flex justify-content-end"
              name="year_param"
              onChange={onChange}
              loading={loading}
              as="select"
              value={theYear}
            >
              {dataSelect.map((selectedData) => (
                <option
                  key={selectedData.id}
                  value={selectedData.id}
                >
                  {selectedData.name}
                </option>
              ))}
            </LoadingInput>


          }
        />

      </Column>
      <Column xs="12" md="4" lg="4" xl="4">
        <LoadingCard
          loading={loading}
          title={`${theWritenMonth ? theWritenMonth : date.month} de ${theYear}`}
          amountValue={data.month}
          selectComponent={
            <LoadingInput
              className="col-4 d-flex justify-content-end"
              name="month_param"
              onChange={onChange}
              loading={loading}
              as="select"
              value={theMonth}
            >
              {monthSelect.map((selectedData) => (
                <option
                  key={selectedData.id}
                  value={selectedData.id}
                >
                  {selectedData.name}
                </option>
              ))}
            </LoadingInput>

          }
        />

      </Column>
      <Column xs="12" md="4" lg="4" xl="4">
        <LoadingCard
          loading={loading}
          title={`Hoje, ${date.weekday}`}
          amountValue={data.daily}

        />
      </Column>
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Dashboard/components/SalesAmountCard/index.jsx